import { KSelectRange, KSpan } from "kahuna-base-react-components"
import { useEffect, useMemo, useState } from "react"
import { convertToMonthYear, subOptionsSetter } from "../../../utility"
import { analysisFilterOptionsKDropdown } from "../../../constants"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import { DateRangeType } from "kahuna-base-react-components/dist/components/KSelectRange/KSelectRange"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { AnalysisSummary } from "../../../types"
import AnalysisLineChart from "./AnalysisLineChart"
import CountryChart from "./CountryChart"
import PlatformChart from "./PlatformChart"
import { MultiValue } from "react-select"

const ChartContainer = ({
  defaultStartDate,
  defaultEndDate,
  filterOptions,
  initialData,
  currency
}: {
  defaultStartDate: Date
  defaultEndDate: Date
  initialData: AnalysisSummary[]
  filterOptions?: { [key: string]: KSelectOption[] }
  currency: string
}) => {
  const [platforms, setPlatforms] = useState<KSelectOption[]>([])

  const [loading, setLoading] = useState<boolean>(false)

  const [dateValues, setDateValues] = useState<DateRangeType>([defaultStartDate, defaultEndDate])
  const [commonDataHolder, setCommonDataHolder] = useState<AnalysisSummary[]>(initialData)
  
  useEffect(() => {
    setCommonDataHolder(initialData)
  }, [initialData])

  useEffect(() => {
    const platformsSetting = async () => {
      if (!filterOptions) return
      if (filterOptions) {
        setLoading(true)
        await subOptionsSetter(analysisFilterOptionsKDropdown[0], filterOptions, setPlatforms)
        setLoading(false)
      }
    }
    if (filterOptions) {
      platformsSetting()
    }
  }, [filterOptions])

  const dateLabels = useMemo(() => {
    if (!(dateValues && dateValues[0] && dateValues[1])) return { start: "", end: "" }
    const startDateYear = dateValues[0].getFullYear()
    const startDateMonth = String(dateValues[0].getMonth() + 1).padStart(2, "0")
    const endDateYear = dateValues[1].getFullYear()
    const endDateMonth = String(dateValues[1].getMonth() + 1).padStart(2, "0")
    return {
      start: convertToMonthYear(`${startDateYear}${startDateMonth}`),
      end: convertToMonthYear(`${endDateYear}${endDateMonth}`)
    }
  }, [dateValues])

  const [selectedSubOptions, setSelectedSubOptions] = useState<KSelectOption | MultiValue<KSelectOption> | undefined>(
    [] as KSelectOption[]
  )

  return (
    <div className="w-full flex flex-col gap-3">
      <div className="flex flex-row justify-end items-center">
        <div className="flex flex-row gap-2 items-center">
          <div className="p-3.5 bg-[#F7F7F7] rounded-[10px] gap-1 h-12 flex items-center">
            <KSpan text={dateLabels.start} color="#000" fontWeight={500} />
            <KSpan text={`-`} color="#000" fontWeight={500} />
            <KSpan text={dateLabels.end} color="#000" fontWeight={500} />
          </div>
          <KSelectRange
            value={dateValues}
            onChange={(event) => {
              setDateValues(event)
            }}
            width="48px"
            height="48px"
            backgroundColor="#F7F7F7"
            hoverBackgroundColor="#F3F3F3"
            boxShadow="none"
          />
        </div>
      </div>
      <div className="flex w-full">
        <AnalysisLineChart
          data={commonDataHolder}
          setData={setCommonDataHolder}
          dateValues={dateValues}
          platformOptions={platforms}
          currency={currency}
          loading={loading}
          selectedSubOptions={selectedSubOptions}
          setSelectedSubOptions={setSelectedSubOptions}
        />
      </div>
      <div className="flex flex-row gap-6 w-full">
        <div className="flex-1 min-h-0">
          <CountryChart dateValues={dateValues} />
        </div>
        <div className="flex-1 min-h-0">
          <PlatformChart
            dateValues={dateValues}
            platformOptions={platforms}
            commonData={commonDataHolder}
            selectedSubOptions={selectedSubOptions}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    filterOptions: state.analysis.filterOptions,
    allSummaries: state.analysis.allSummaries
  }
}

export default connect(mapStateToProps)(ChartContainer)
